import { render, staticRenderFns } from "./DictionaryGeneralEffectsBeam.vue?vue&type=template&id=a2603758&"
import script from "./DictionaryGeneralEffectsBeam.vue?vue&type=script&lang=js&"
export * from "./DictionaryGeneralEffectsBeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports